import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, Clock, Eye, User } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


const TreeCategoryList1 = ({ data, onArticleClick, variant = "grid" ,category_key}) => {

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const Card = ({ item, variant }) => (
    <article
      key={item.id}
      className="
        group relative bg-white rounded-2xl overflow-hidden
        border border-gray-200/60 hover:border-orange-500
        shadow-[0_8px_28px_rgba(0,0,0,0.05)]
        hover:shadow-[0_18px_55px_rgba(249,115,22,0.22)]
        transition-all duration-300 flex flex-col h-full
        select-none
      "
    >
      <div
        className={`relative ${variant === "slider" ? "h-56 md:h-[450px]" : "h-56"} overflow-hidden`}
      >
        <img
          src={item?.image || item?.cover_image}
          alt={item.title}
          loading="lazy"
          className={`h-full w-full  transition-transform duration-700 ease-out group-hover:scale-110`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent" />
        <span className="absolute top-0 left-0 text-xs font-semibold px-3 py-1 rounded-e-full bg-orange-500/90 text-white shadow">
          {item.category_name}
        </span>
      </div>

      <div className="py-5 px-4 flex flex-col gap-2 flex-1">
        <span className="flex items-center gap-2">
          <User size={14} className="opacity-60" />
          <span className="font-medium text-gray-700 ">
            {item.author || "THT"}
          </span>
        </span>

        <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-2 text-[13px] text-gray-500">
          <span className="flex items-center gap-2">
            <Clock size={14} className="opacity-60" />
            {new Date(item.updated_at).toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </span>

          <span className="inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-orange-50 text-orange-700 font-semibold">
            <Eye size={14} />
            {item.view ?? 0}
            <span className="font-normal text-orange-600">views</span>
          </span>
        </div>

        <h3 className="text-[18px] sm:text-[16px] font-semibold text-gray-900 leading-snug tracking-tight line-clamp-2 group-hover:text-orange-600 transition-colors">
          {item.title}
        </h3>

        <p className="text-[14.5px] sm:text-[15px] text-gray-600 leading-relaxed line-clamp-3">
          {stripHtml(category_key === 'magazine' ? item?.cover_description : item?.description)}
        </p>

        <div className="pt-3 flex flex-wrap items-center gap-1 justify-between mt-auto">
          <button
            onClick={() => onArticleClick(item)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-orange-50 text-orange-600 font-medium text-xs xl:text-sm hover:bg-orange-100 transition-colors w-auto"
          >
            Read More <span className="text-sm">→</span>
          </button>

          {item.post_url && (
            <a
              href={item.post_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-gray-100 text-gray-700 font-medium text-xs xl:text-sm hover:bg-gray-200 transition-colors w-auto"
            >
              Visit on Site <span className="text-sm">↗</span>
            </a>
          )}
        </div>
      </div>
    </article>
  );

  // ✅ VIDEO ONLY: slider
  if (variant === "slider") {
    return (
      <div className="video-swiper group related">
        <button ref={prevRef} className="swiper-btn-prev" type="button">
          <ChevronLeft size={22} strokeWidth={2.5} />
        </button>
        <button ref={nextRef} className="swiper-btn-next" type="button">
          <ChevronRight size={22} strokeWidth={2.5} />
        </button>
        <Swiper
          modules={[Navigation, Pagination]}
          slidesPerView={1}
          spaceBetween={16}
          loop={data.length > 1}
          // pagination={{ clickable: true }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          className="pb-10"
        >
          {data.map((item, idx) => (
            <SwiperSlide key={`${item?.id || "vid"}-${idx}`} className="h-auto">
              <div className="h-full">
                <Card item={item} variant={variant} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }

  // ✅ BLOGS: grid
  return (
    <div className="grid gap-3 md:gap-4 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
      {data?.map((item) => (
        <Card key={item.id} item={item} />
      ))}
    </div>
  );
};

export default TreeCategoryList1;

function stripHtml(html) {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "").slice(0, 140) + "...";
}
